import {ChromoLogoColor, StockLogo} from "../selectableObjects";
import {StocklogoController} from "../stocklogos/stocklogoController";
import type {StockLogoPoolEntry} from "../stocklogos/stocklogoController";
import {EventVerteiler} from "../../global/eventVerteiler";
import {createGUID} from "../../global/globalUtils";
import {CONSTANTS} from "../meta_data";
import globalsObject from "../globalsObject";

export const PATTERN_EVENTNAMES = {
    COLOR_CHANGED : "patternChangedEvent",
    CREATED: "patternCreatedEvent",
    DELETED: "patternDeletedEvent",
    LOADED : "patternsLoadedEvent",
    CHANGESIZEUP_REQUEST:"patternChangeSizeUpEvent",
    CHANGESIZEDOWN_REQUEST:"patternChangeSizeDownEvent",
    CHANGESIZETOSTEP_REQUEST:"patternChangeSizeToStepEvent",
    SIZE_CHANGED : "patternSizeChangedEvent",
    MAX_SIZE_REACHED : "patternMaxSizeReachedEvent",
    MIN_SIZE_REACHED : "patternMinSizeReachedEvent",
    REQUEST_COLOR_CHANGE: "patternColorChangerequestEvent",
    FILLPATTERNSTEPSIZE:"fillPatternStepSizeEvent",
    FILLVORSCHAUBILD: "fillpatternVorschauBildEvent",
    // PATTERNANKER_LOADED: "patternAnkerLoadedEvent"
    COLORVERSION_CLICKED: "patternColorVersionClickedEvent",
    SETPATTERN_TO_ALIAS: "setPatternToPatternFromAliasEvent",
    DELETION_REQUEST: "deletePatternForColorCodeAndAliases",
    PATTERN_ABOUT_TO_BE_DELETED : "patternIsAboutToBeDeleted",
    SELECTED:"patternSelectedForEdit",
};


export class PatternFactory {

    public static createPattern(stockLogoID:number|string, colors:ChromoLogoColor[], forColorCodeNr, insertTargetSize:number):void {
        const patternPoolEntry = StocklogoController.getLogo(parseInt(stockLogoID as string)) as StockLogoPoolEntry;
        const baseStockLogo = PatternFactory.createBaseStockLogo(patternPoolEntry, forColorCodeNr, colors, insertTargetSize);
        globalsObject.resourceManager.executeInvalidation("createPattern"+forColorCodeNr);
        globalsObject.resourceManager.createTask("insertPattern_"+forColorCodeNr)
            .discardAfterExecution()
            .when("chromoLogoSVG"+baseStockLogo.id, "loaded")
            .thenDo(
                function(){
                    PatternFactory.registerPatternCreatedResource(forColorCodeNr);
                    const data = {
                        stockLogo:baseStockLogo,
                        baseColorValue:globalsObject.controller.getColorValueForColorCode(globalsObject.controller.getColorCodeFromColorCodeNr(forColorCodeNr))
                    };
                    EventVerteiler.broadcast(
                        PATTERN_EVENTNAMES.CREATED,
                        data);
                    EventVerteiler.broadcast("updateOrCreateFarbGedaechtnisEvent", {colorClodeNr:forColorCodeNr, colors:baseStockLogo.colors});
                    EventVerteiler.broadcast("fillMyColorChoiceColorCirclesEvent", globalsObject.controller.getColorCodeFromColorCodeNr(forColorCodeNr))
                }
        );
    }

    private static registerPatternCreatedResource(forColorCodeNr) {
        globalsObject.resourceManager.registerResource(
            {
                resourceName:"patterncreatedFor"+forColorCodeNr,
                invalidatedWhen:"createPattern"+forColorCodeNr,
                startingStati:["done"]
            }
        );
    }

    private static createBaseStockLogo(patternPoolEntry:StockLogoPoolEntry, colorCodeNr:number, colors:ChromoLogoColor[]=[], tileWidthInCM:number|null = null):StockLogo {
        const id = createGUID();
        const baseStockLogo =  new StockLogo({
            id          : id,
            partName    : "",
            filename  : patternPoolEntry.previewPicture,
            pathToLogo  : "/",
            logoId      : null,
            chromoLogoId: null,
            stockLogoID : patternPoolEntry.stockLogoID.toString(),
            palette     : CONSTANTS.STANDARD_PALETTENCLUSTER,
            isAILogo    :false
        });
        baseStockLogo.makeUntouchable(CONSTANTS.FLOAT_BOTTOM);
        baseStockLogo.keepSeparate = false;
        baseStockLogo.isPattern = true;
        baseStockLogo.clampToColor = colorCodeNr;
        baseStockLogo.setSizes(patternPoolEntry.standardSizeCM, patternPoolEntry.minSizeCM, patternPoolEntry.maxSizeCM);
        baseStockLogo.targetSizeCM = tileWidthInCM || patternPoolEntry.standardSizeCM
        if(colors.length > 0) {
            baseStockLogo.colors = colors;
        }
        const useVorbelegung = baseStockLogo.colors.filter(c=>c.colorIntValue !== null).length===0;
        baseStockLogo.getOriginalSVG(useVorbelegung);
        return baseStockLogo;
    }
}

